<template>
  <div>
    <b-modal
      :id="`modal-pay-doctor`"
      :no-close-on-backdrop="true"
      :title="$t('surgery.pay-doctor')"
      ok-only
      :ok-title="$t('surgery.pay-doctor')"
      @ok="payDoctorPrice()"
    >
      <b-card-text>
        <h5>{{ $t("surgery.pay-doctor") }}</h5>
        {{
          $t("surgery.Are you sure do you want to pay doctor for this surgery")
        }}
      </b-card-text>
    </b-modal>
    <b-modal
      :id="`modal-pay-selected-items`"
      :no-close-on-backdrop="true"
      :title="$t('surgery.pay-selected')"
      ok-only
      :ok-title="$t('surgery.pay-doctor')"
      @ok="paySelectedItems()"
    >
      <b-card-text>
        <h5>{{ $t("surgery.pay-selected") }}</h5>
        {{ $t("surgery.pay-selected-items-confirmation") }}
        <div class="mt-2">
          <div>
            {{ $t("common.selected-items") }}: {{ selectedItems.length }}
          </div>
          <div>
            {{ $t("accounting.doctor_assistant_price") }}:
            {{ formatIQDCurrency(selectedItemsTotalDoctorAssistantPrice) }}
          </div>
          <h4>
            {{ $t("hospital.doctorTotalAfterDiscount") }}:
            {{ formatIQDCurrency(selectedItemsNetTotal) }}
          </h4>
        </div>
      </b-card-text>
    </b-modal>
    <!-- Payment Receipt Modal -->
    <b-modal
      id="modal-payment-receipt"
      :title="$t('surgery.payment-receipt')"
      size="xl"
      hide-footer
      @hide="closePaymentReceiptModal"
    >
      <DoctorPaymentReceipt
        v-if="paymentReceiptData.length > 0"
        :data="paymentReceiptData"
        :doctor-name="doctorName"
        :type="paymentReceiptType"
        :is-all-payment="paymentReceiptIsAll"
        :is-doctor-assistant="paymentReceiptIsDoctorAssistant"
        :total-amount="paymentReceiptTotalAmount"
        :total-discount="paymentReceiptTotalDiscount"
        :from-date="paymentReceiptFromDate"
        :to-date="paymentReceiptToDate"
      />
    </b-modal>
    <!-- Account Statement Modal -->
    <b-modal
      id="modal-account-statement"
      :title="$t('hospital.doctor-account-statement')"
      size="xl"
      hide-footer
      @hide="closeAccountStatementModal"
    >
      <DoctorAccountStatement
        v-if="accountStatementData.length > 0"
        :data="accountStatementData"
        :doctor-name="doctorName"
        :type="accountStatementType"
        :is-paid="accountStatementIsPaid"
        :total-amount="accountStatementTotalAmount"
        :total-discount="accountStatementTotalDiscount"
        :from-date="accountStatementFromDate"
        :to-date="accountStatementToDate"
      />
      <div v-else class="text-center p-4">
        <b-spinner />
        <p class="mt-2">
          {{ $t("common.loading") }}
        </p>
      </div>
    </b-modal>
    <b-card>
      <b-tabs v-model="activeTab">
        <b-tab
          :title="$t('accounting.dosnt-recive-money')"
          :active="activeTab === 0"
        >
          <h1 class="text-center mb-3">
            {{ $t("common.reports") }}
          </h1>
          <div>
            <b-row class="mb-3">
              <b-col>
                <h4 class="mb-1">
                  {{ $t("accounting.doctor_assistant_price") }}
                </h4>
                <b-badge variant="primary">{{
                  formatIQDCurrency(unifiedTotals.doctorAssistantPrice || 0)
                }}</b-badge>
              </b-col>
            </b-row>

            <b-row class="d-flex justify-content-end mb-2">
              <b-col lg="2">
                <b-form-group
                  :label="$t('hospital.patient-name')"
                  label-for="Name"
                >
                  <b-form-input
                    id="Name"
                    v-model="name"
                    :placeholder="$t('hospital.patient-name')"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="2">
                <b-form-group :label="$t('common.from')" label-for="entry_date">
                  <datepicker
                    v-model="from"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="2">
                <b-form-group :label="$t('common.to')" label-for="entry_date">
                  <datepicker
                    v-model="to"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col>
              <b-col class="d-flex align-items-center mb-2 mb-lg-0">
                <b-button
                  variant="primary"
                  class="mx-2"
                  @click="getUnifiedData()"
                >
                  {{ $t("common.search") }}
                </b-button>
                <b-button
                  v-if="selectedItems.length > 0 && activeTab === 0"
                  variant="primary"
                  class="mx-2"
                  @click="showModalPaySelected()"
                >
                  <feather-icon
                    icon="CheckSquareIcon"
                    size="16"
                    class="mr-50"
                  />
                  {{ $t("surgery.pay-selected") }} ({{ selectedItems.length }})
                </b-button>
                <b-button
                  v-if="unifiedData.length > 0"
                  variant="success"
                  class="mx-2"
                  @click="showAccountStatementModal('unified')"
                >
                  <feather-icon icon="FileTextIcon" size="16" class="mr-50" />
                  {{ $t("hospital.doctor-account-statement") }}
                </b-button>
              </b-col>
            </b-row>

            <b-table
              v-if="!loading"
              :items="paginatedUnifiedData"
              responsive
              :fields="
                activeTab === 1
                  ? unifiedTableColumnsWithPaymentDate
                  : unifiedTableColumns
              "
              primary-key="id"
              show-empty
              empty-text="No matching results found"
              class="position-relative"
            >
              <template #head(selected)>
                <b-form-checkbox
                  v-if="activeTab === 0"
                  :checked="areAllItemsSelected"
                  :indeterminate="areSomeItemsSelected"
                  @change="toggleSelectAll"
                />
              </template>
              <template #cell(selected)="data">
                <b-form-checkbox
                  v-if="activeTab === 0"
                  :checked="isItemSelected(data.item)"
                  @input="handleCheckboxChange(data.item, $event)"
                />
              </template>
              <template #cell(type)="data">
                <b-badge
                  :variant="
                    data.item.type === 'surgery'
                      ? 'primary'
                      : data.item.type === 'stay'
                      ? 'info'
                      : data.item.type === 'consultancy'
                      ? 'warning'
                      : 'success'
                  "
                >
                  {{ getTypeLabel(data.item.type) }}
                </b-badge>
              </template>
              <template #cell(doctor_assistant_price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.doctor_assistant_price || 0) }}
                </span>
              </template>
              <template #cell(procedures)="data">
                {{ getSurgeryName(data.item) }}
              </template>
              <template #cell(approved_at)="data">
                <span class="text-nowrap">
                  {{ formatPaymentDate(data.item.approved_at) }}
                </span>
              </template>
              <template #cell(payment_date)="data">
                <span class="text-nowrap">
                  {{ formatPaymentDate(data.item.payment_date) }}
                </span>
              </template>
              <template #cell(actions)="data">
                <div class="d-flex">
                  <b-button
                    v-if="activeTab === 0"
                    variant="primary"
                    size="sm"
                    class="mr-1"
                    @click="handlePayAssistant(data.item)"
                  >
                    {{ $t("surgery.pay-doctor") }}
                  </b-button>
                </div>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted"
                    >{{ $t("common.showing") }}
                    {{
                      unifiedData.length > 0
                        ? (localPage - 1) * localPageSize + 1
                        : 0
                    }}
                    {{ $t("common.to") }}
                    {{
                      Math.min(localPage * localPageSize, unifiedData.length)
                    }}
                    {{ $t("common.of") }}
                    {{ unifiedData.length }}
                  </span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >
                  <b-pagination
                    v-model="localPage"
                    :total-rows="unifiedData.length"
                    :per-page="localPageSize"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-tab>
        <b-tab :title="$t('accounting.recive-money')" :active="activeTab === 1">
          <h1 class="text-center mb-3">
            {{ $t("common.reports") }}
          </h1>
          <div>
            <b-row class="mb-3">
              <b-col>
                <h4 class="mb-1">
                  {{ $t("accounting.doctor_assistant_price") }}
                </h4>
                <b-badge variant="primary">{{
                  formatIQDCurrency(unifiedTotals.doctorAssistantPrice || 0)
                }}</b-badge>
              </b-col>
            </b-row>

            <b-row class="d-flex justify-content-end mb-2">
              <b-col lg="2">
                <b-form-group
                  :label="$t('hospital.patient-name')"
                  label-for="Name"
                >
                  <b-form-input
                    id="Name"
                    v-model="name"
                    :placeholder="$t('hospital.patient-name')"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="2">
                <b-form-group :label="$t('common.from')" label-for="entry_date">
                  <datepicker
                    v-model="from"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="2">
                <b-form-group :label="$t('common.to')" label-for="entry_date">
                  <datepicker
                    v-model="to"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col>
              <b-col v-if="activeTab === 1" lg="2">
                <b-form-group
                  label="من تاريخ الدفع"
                  label-for="from_payment_date"
                >
                  <datepicker
                    v-model="fromPaymentDate"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col>
              <b-col v-if="activeTab === 1" lg="2">
                <b-form-group
                  label="إلى تاريخ الدفع"
                  label-for="to_payment_date"
                >
                  <datepicker
                    v-model="toPaymentDate"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col>
              <b-col class="d-flex align-items-center mb-2 mb-lg-0">
                <b-button
                  variant="primary"
                  class="mx-2"
                  @click="getUnifiedData()"
                >
                  {{ $t("common.search") }}
                </b-button>
                <b-button
                  v-if="unifiedData.length > 0"
                  variant="success"
                  class="mx-2"
                  @click="showAccountStatementModal('unified')"
                >
                  <feather-icon icon="FileTextIcon" size="16" class="mr-50" />
                  {{ $t("hospital.doctor-account-statement") }}
                </b-button>
              </b-col>
            </b-row>

            <b-table
              v-if="!loading"
              :items="paginatedUnifiedData"
              responsive
              :fields="unifiedTableColumnsWithPaymentDate"
              primary-key="id"
              show-empty
              empty-text="No matching results found"
              class="position-relative"
            >
              <template #cell(type)="data">
                <b-badge
                  :variant="
                    data.item.type === 'surgery'
                      ? 'primary'
                      : data.item.type === 'stay'
                      ? 'info'
                      : data.item.type === 'consultancy'
                      ? 'warning'
                      : 'success'
                  "
                >
                  {{ getTypeLabel(data.item.type) }}
                </b-badge>
              </template>
              <template #cell(doctor_assistant_price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.doctor_assistant_price || 0) }}
                </span>
              </template>
              <template #cell(procedures)="data">
                {{ getSurgeryName(data.item) }}
              </template>
              <template #cell(approved_at)="data">
                <span class="text-nowrap">
                  {{ formatPaymentDate(data.item.approved_at) }}
                </span>
              </template>
              <template #cell(payment_date)="data">
                <span class="text-nowrap">
                  {{ formatPaymentDate(data.item.payment_date) }}
                </span>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted"
                    >{{ $t("common.showing") }}
                    {{
                      unifiedData.length > 0
                        ? (localPage - 1) * localPageSize + 1
                        : 0
                    }}
                    {{ $t("common.to") }}
                    {{
                      Math.min(localPage * localPageSize, unifiedData.length)
                    }}
                    {{ $t("common.of") }}
                    {{ unifiedData.length }}
                  </span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >
                  <b-pagination
                    v-model="localPage"
                    :total-rows="unifiedData.length"
                    :per-page="localPageSize"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BIconSearch,
  BTab,
  BTabs,
  BBadge,
  BModal,
  BCardText,
  BFormCheckbox,
} from "bootstrap-vue";
import Datepicker from "vuejs-datepicker";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

const AutoComplete = () => import("@/components/common/AutoComplete.vue");
const DoctorPaymentReceipt = () =>
  import("@/components/printables/DoctorPaymentReceipt.vue");
const DoctorAccountStatement = () =>
  import("@/components/printables/DoctorAccountStatement.vue");

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BIconSearch,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    Datepicker,
    AutoComplete,
    BTab,
    BTabs,
    ToastificationContent,
    BBadge,
    BModal,
    BCardText,
    BFormCheckbox,
    DoctorPaymentReceipt,
    DoctorAccountStatement,
  },

  props: ["patientCardId", "isHistory"],
  data() {
    return {
      params: {
        form: {},
        path: "",
      },
      loading: true,
      activeTab: 0,
      name: "",
      from: "",
      to: "",
      fromPaymentDate: "",
      toPaymentDate: "",
      payDoctorData: {},
      // Unified data
      unifiedData: [],
      unifiedDataCount: 0,
      unifiedTake: 1000, // Fetch 1000 items from API
      localPageSize: 10, // Display 10 items per page locally
      localPage: 1, // Local pagination page
      selectedItems: [],
      selectedItemKeys: new Set(),
      unifiedTotals: {
        doctorAssistantPrice: 0,
        netTotal: 0,
      },
      unifiedTableColumns: [
        {
          key: "selected",
          label: "",
          sortable: false,
        },
        {
          key: "patient_name",
          label: this.$t("hospital.patient-name"),
          sortable: true,
        },
        {
          key: "type",
          label: this.$t("common.type"),
          sortable: true,
        },
        {
          key: "procedures",
          label: this.$t("surgery.surgery-or-service"),
          sortable: true,
        },
        {
          key: "doctor_assistant_price",
          label: this.$t("accounting.doctor_assistant_price"),
          sortable: true,
        },
        {
          key: "approved_at",
          label: this.$t("common.date"),
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("common.actions"),
        },
      ],
      // Payment Receipt data
      paymentReceiptData: [],
      paymentReceiptType: "unified",
      paymentReceiptIsAll: false,
      paymentReceiptIsDoctorAssistant: true, // This is for doctor assistants
      paymentReceiptTotalAmount: 0,
      paymentReceiptTotalDiscount: 0,
      paymentReceiptFromDate: "",
      paymentReceiptToDate: "",
      doctorName: "",
      // Account Statement data
      accountStatementData: [],
      accountStatementType: "unified",
      accountStatementIsPaid: false,
      accountStatementTotalAmount: 0,
      accountStatementTotalDiscount: 0,
      accountStatementFromDate: "",
      accountStatementToDate: "",
    };
  },
  computed: {
    selectedItemsTotalDoctorAssistantPrice() {
      return this.selectedItems.reduce(
        (sum, item) => sum + (parseFloat(item.doctor_assistant_price) || 0),
        0
      );
    },
    selectedItemsNetTotal() {
      return this.selectedItemsTotalDoctorAssistantPrice;
    },
    areAllItemsSelected() {
      if (this.unifiedData.length === 0) return false;
      return this.unifiedData.every((item) => this.isItemSelected(item));
    },
    areSomeItemsSelected() {
      return (
        this.selectedItems.length > 0 && !this.areAllItemsSelected
      );
    },
    paginatedUnifiedData() {
      const start = (this.localPage - 1) * this.localPageSize;
      const end = start + this.localPageSize;
      return this.unifiedData.slice(start, end);
    },
    unifiedTableColumnsWithPaymentDate() {
      const columns = [...this.unifiedTableColumns];
      // Add payment_date column only for paid tab (activeTab === 1)
      if (this.activeTab === 1) {
        const approvedAtIndex = columns.findIndex(
          (col) => col.key === "approved_at"
        );
        if (approvedAtIndex !== -1) {
          columns.splice(approvedAtIndex + 1, 0, {
            key: "payment_date",
            label: "تاريخ الدفع",
            sortable: true,
          });
        }
      }
      return columns;
    },
  },
  watch: {
    activeTab() {
      // Reset to page 1 when switching tabs
      this.localPage = 1;
      this.getUnifiedData();
    },
    $route(to) {
      // Get doctor name from query parameter if available when route changes
      if (to.query.doctorName) {
        this.doctorName = to.query.doctorName;
      }
    },
  },
  mounted() {
    // Get doctor name from query parameter if available
    if (this.$route.query.doctorName) {
      this.doctorName = this.$route.query.doctorName;
    }
    this.getUnifiedData();
  },
  methods: {
    formatIQDCurrency(value) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "IQD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      return formatter.format(value);
    },
    getItemKey(item) {
      if (!item) return "";
      const id =
        item.id ||
        item.invoice_id ||
        item.patient_card_surgery_id ||
        item.patient_card_stay_id ||
        "";
      const type = item.type || "";
      return `${type}_${id}`;
    },
    isItemSelected(item) {
      if (!item) return false;
      const itemKey = this.getItemKey(item);
      return this.selectedItemKeys.has(itemKey);
    },
    handleCheckboxChange(item, checked) {
      if (!item) return;
      let isChecked = false;
      if (typeof checked === "boolean") {
        isChecked = checked;
      } else if (checked && checked.target) {
        isChecked = checked.target.checked;
      } else {
        isChecked = !!checked;
      }

      const itemKey = this.getItemKey(item);

      if (isChecked) {
        if (!this.selectedItemKeys.has(itemKey)) {
          this.selectedItemKeys.add(itemKey);
          this.selectedItems.push({ ...item });
        }
      } else if (this.selectedItemKeys.has(itemKey)) {
        this.selectedItemKeys.delete(itemKey);
        const index = this.selectedItems.findIndex((selected) => {
          if (!selected) return false;
          return this.getItemKey(selected) === itemKey;
        });
        if (index !== -1) {
          this.selectedItems.splice(index, 1);
        }
      }
    },
    toggleSelectAll(event) {
      const isChecked = event;
      if (isChecked) {
        this.unifiedData.forEach((item) => {
          if (!item) return;
          const itemKey = this.getItemKey(item);
          if (!this.selectedItemKeys.has(itemKey)) {
            this.selectedItemKeys.add(itemKey);
            this.selectedItems.push({ ...item });
          }
        });
      } else {
        this.selectedItems = [];
        this.selectedItemKeys = new Set();
      }
    },
    showModalPaySelected() {
      this.$bvModal.show("modal-pay-selected-items");
    },
    async paySelectedItems() {
      if (this.selectedItems.length === 0) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "No items selected",
            icon: "AlertCircleIcon",
            variant: "warning",
            text: "Please select at least one item to pay",
          },
        });
        return;
      }

      try {
        const invoiceIds = [];

        this.selectedItems.forEach((item) => {
          if (!item) return;
          let possibleInvoiceId =
            item.invoice_id ||
            item.invoice_out_clinic_id ||
            item.patient_card_surgery_id ||
            item.patient_card_stay_id ||
            item.patient_card_consultancy_id ||
            (item.patient_card_surgery &&
              item.patient_card_surgery.invoice_id) ||
            (item.patient_card_stay && item.patient_card_stay.invoice_id);

          if (!possibleInvoiceId && item.id) {
            const idValue = item.id;
            if (idValue !== null && idValue !== undefined && idValue !== "") {
              possibleInvoiceId = idValue;
            }
          }

          if (possibleInvoiceId) {
            invoiceIds.push(possibleInvoiceId);
          }
        });

        if (invoiceIds.length === 0) {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "No valid invoices",
              icon: "AlertCircleIcon",
              variant: "warning",
              text: `No valid invoice IDs found in ${this.selectedItems.length} selected items.`,
            },
          });
          return;
        }

        // Use the bulk payment endpoint with new format
        const payments = invoiceIds.map((invoiceId) => ({
          assistant_id: this.$route.params.id,
          invoice_id: invoiceId,
        }));

        this.params.form = { payments };
        this.params.path = "invoices/bulk-pay-assistant";

        const response = await this.$store.dispatch("put", this.params);

        this.showPaymentReceiptModal("unified", this.selectedItems, false);

        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Payment Successful",
            icon: "CheckCircleIcon",
            variant: "success",
            text:
              response.data?.message ||
              `Successfully paid ${invoiceIds.length} invoices`,
          },
        });

        this.selectedItems = [];
        this.selectedItemKeys = new Set();
        await this.getUnifiedData();
      } catch (error) {
        console.error("Bulk payment error:", error);
        await this.getUnifiedData();
      }
    },
    async getUnifiedData() {
      this.loading = true;

      this.selectedItems = [];
      this.selectedItemKeys = new Set();

      let url = `/doctor-assistant/${this.$route.params.id}/unified-data?page=1&take=${this.unifiedTake}&payment_status=${this.activeTab}&sort=-id`;

      if (this.from) {
        url += `&from=${this.formatDate(this.from)}`;
      }
      if (this.to) {
        url += `&to=${this.formatDate(this.to)}`;
      }
      if (this.name) {
        url += `&filter[patient_name]=${this.name}`;
      }
      // Add payment_date filters only for paid tab (activeTab === 1)
      if (this.activeTab === 1) {
        if (this.fromPaymentDate) {
          url += `&payment_date_from=${this.formatDate(this.fromPaymentDate)}`;
        }
        if (this.toPaymentDate) {
          url += `&payment_date_to=${this.formatDate(this.toPaymentDate)}`;
        }
      }

      await this.getList(url);

      this.unifiedDataCount = this.all_data.total || 0;
      this.unifiedData = this.all_data.data || [];

      // Extract doctor assistant name from the first item if not already set from query parameter
      if (!this.doctorName && this.unifiedData.length > 0) {
        for (const item of this.unifiedData) {
          if (
            item.doctor_assistant_patient_card_surgery &&
            item.doctor_assistant_patient_card_surgery.doctor_assistant &&
            item.doctor_assistant_patient_card_surgery.doctor_assistant.name
          ) {
            this.doctorName =
              item.doctor_assistant_patient_card_surgery.doctor_assistant.name;
            break;
          }
        }
      }

      this.localPage = 1;

      this.unifiedTotals.doctorAssistantPrice = this.unifiedData.reduce(
        (sum, item) => sum + parseFloat(item.doctor_assistant_price || 0),
        0
      );
      this.unifiedTotals.netTotal = this.unifiedTotals.doctorAssistantPrice;

      this.loading = false;
    },
    getTypeLabel(type) {
      const labels = {
        surgery: this.$t("hospital.doctor-surgeries"),
        stay: this.$t("hospital.doctor-patient-stay"),
        consultancy: this.$t("surgery.doctor-consultancies"),
        nicu: this.$t("incubator.nicu-patients"),
      };
      return labels[type] || type;
    },
    getSurgeryName(item) {
      if (item.invoice && item.invoice.surgery_name) {
        return item.invoice.surgery_name;
      }
      if (item.invoice && item.invoice.service_name) {
        return item.invoice.service_name;
      }
      if (item.invoice && item.invoice.name) {
        return item.invoice.name;
      }
      if (item.invoice_out_clinic && item.invoice_out_clinic.surgery_name) {
        return item.invoice_out_clinic.surgery_name;
      }
      if (item.invoice_out_clinic && item.invoice_out_clinic.service_name) {
        return item.invoice_out_clinic.service_name;
      }
      if (item.invoice_out_clinic && item.invoice_out_clinic.name) {
        return item.invoice_out_clinic.name;
      }
      if (
        item.invoice_out_clinic &&
        item.invoice_out_clinic.service &&
        item.invoice_out_clinic.service.title
      ) {
        return item.invoice_out_clinic.service.title;
      }
      if (
        item.invoice_patient_surgery &&
        item.invoice_patient_surgery.surgery_name
      ) {
        return item.invoice_patient_surgery.surgery_name;
      }
      if (
        item.invoice_patient_surgery &&
        item.invoice_patient_surgery.service_name
      ) {
        return item.invoice_patient_surgery.service_name;
      }
      if (item.invoice_patient_surgery && item.invoice_patient_surgery.name) {
        return item.invoice_patient_surgery.name;
      }
      if (item.service_name) {
        return item.service_name;
      }
      if (item.procedures) {
        return item.procedures;
      }
      if (item.invoice && item.invoice.service && item.invoice.service.title) {
        return item.invoice.service.title;
      }
      if (item.invoice && item.invoice.surgery && item.invoice.surgery.title) {
        return item.invoice.surgery.title;
      }

      switch (item.type) {
        case "stay":
          return "إقامة المريض";
        case "outclinic":
          return "خدمة عيادة خارجية";
        case "surgery":
          return "عملية جراحية";
        case "consultancy":
          return "استشارة طبية";
        case "nicu":
          return "خدمات الخدج / العناية المركزة";
        default:
          return "-";
      }
    },
    handlePayAssistant(item) {
      this.payDoctorData = item;
      this.$bvModal.show("modal-pay-doctor");
    },
    payDoctorPrice() {
      const invoiceId =
        this.payDoctorData.invoice_id ||
        this.payDoctorData.id ||
        this.payDoctorData.invoice_out_clinic_id ||
        this.payDoctorData.patient_card_surgery_id;

      if (!invoiceId) {
        const availableFields = Object.keys(this.payDoctorData).join(", ");
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Validation Error",
            variant: "danger",
            text: `Invoice ID not found. Available fields: ${availableFields}`,
          },
        });
        return;
      }

      this.params.form = {
        assistant_id: this.$route.params.id,
        invoice_id: invoiceId,
      };
      this.params.path = "/pay-assistant";

      this.$store
        .dispatch("put", this.params)
        .then((response) => {
          this.showPaymentReceiptModal("unified", [this.payDoctorData], false);

          this.getUnifiedData();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Success",
              variant: "success",
              text:
                response.data?.message ||
                "Assistant payments marked as paid successfully",
            },
          });
        })
        .catch((error) => {
          console.error("Payment error:", error);
          if (error.response) {
            if (error.response.status === 400) {
              Object.keys(error.response.data).forEach((item) => {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Validation Error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Error",
                  variant: "danger",
                  text: error.response.data?.message || "Payment failed",
                },
              });
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Error",
                variant: "danger",
                text: "Network error or request failed",
              },
            });
          }
        });
    },
    formatDate(date) {
      const newDate = new Date(date);
      const year = newDate.getFullYear();
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const day = String(newDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    formatPaymentDate(date) {
      if (!date) return "-";
      const newDate = new Date(date);
      const year = newDate.getFullYear();
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const day = String(newDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    // Payment Receipt Methods
    showPaymentReceiptModal(type, data, isAll = false) {
      this.paymentReceiptType = type;
      this.paymentReceiptIsAll = isAll;
      this.paymentReceiptData = Array.isArray(data) ? data : [data];

      this.paymentReceiptTotalAmount = this.paymentReceiptData.reduce(
        (sum, item) => sum + parseFloat(item.doctor_assistant_price || 0),
        0
      );

      // No discount for doctor assistant price
      this.paymentReceiptTotalDiscount = 0;

      this.paymentReceiptFromDate = this.from ? this.formatDate(this.from) : "";
      this.paymentReceiptToDate = this.to ? this.formatDate(this.to) : "";

      this.$bvModal.show("modal-payment-receipt");
    },
    closePaymentReceiptModal() {
      this.paymentReceiptData = [];
    },
    // Account Statement Methods
    async showAccountStatementModal(type) {
      this.accountStatementType = "unified";
      this.accountStatementData = [];
      // Set payment status based on active tab (0 = unpaid, 1 = paid)
      this.accountStatementIsPaid = this.activeTab === 1;

      // Fetch all data without pagination using unified endpoint first
      await this.fetchAllDataForStatement(type);

      // Open modal after data is fetched and name is extracted
      this.$bvModal.show("modal-account-statement");
    },
    async fetchAllDataForStatement(type) {
      let url = `/doctor-assistant/${this.$route.params.id}/unified-data?page=1&take=1000&payment_status=${this.activeTab}&sort=-id`;

      if (this.from) {
        url += `&from=${this.formatDate(this.from)}`;
      }
      if (this.to) {
        url += `&to=${this.formatDate(this.to)}`;
      }
      if (this.name) {
        url += `&filter[patient_name]=${this.name}`;
      }
      // Add payment_date filters only for paid tab (activeTab === 1)
      if (this.activeTab === 1) {
        if (this.fromPaymentDate) {
          url += `&payment_date_from=${this.formatDate(this.fromPaymentDate)}`;
        }
        if (this.toPaymentDate) {
          url += `&payment_date_to=${this.formatDate(this.toPaymentDate)}`;
        }
      }

      await this.getList(url);

      this.accountStatementData = this.all_data.data || [];

      // Extract doctor assistant name from the data only if not already set from query parameter
      if (!this.doctorName && this.accountStatementData.length > 0) {
        for (const item of this.accountStatementData) {
          if (
            item.doctor_assistant_patient_card_surgery &&
            item.doctor_assistant_patient_card_surgery.doctor_assistant &&
            item.doctor_assistant_patient_card_surgery.doctor_assistant.name
          ) {
            this.doctorName =
              item.doctor_assistant_patient_card_surgery.doctor_assistant.name;
            break; // Found the name, stop searching
          }
        }
      }

      // Fallback: if name still not found, try to get it from unifiedData
      if (!this.doctorName && this.unifiedData.length > 0) {
        for (const item of this.unifiedData) {
          if (
            item.doctor_assistant_patient_card_surgery &&
            item.doctor_assistant_patient_card_surgery.doctor_assistant &&
            item.doctor_assistant_patient_card_surgery.doctor_assistant.name
          ) {
            this.doctorName =
              item.doctor_assistant_patient_card_surgery.doctor_assistant.name;
            break;
          }
        }
      }

      // Ensure doctorName is set - if still empty, set a default
      if (!this.doctorName) {
        this.doctorName =
          this.$t("hospital.doctor-assistant") || "Doctor Assistant";
      }

      // Calculate totals from unified data structure
      // doctor_assistant_price is the amount to display
      this.accountStatementTotalAmount = this.accountStatementData.reduce(
        (sum, item) => sum + parseFloat(item.doctor_assistant_price || 0),
        0
      );

      // No discount for doctor assistant price
      this.accountStatementTotalDiscount = 0;

      // Save current date range (for printing header)
      this.accountStatementFromDate = this.from
        ? this.formatDate(this.from)
        : "";
      this.accountStatementToDate = this.to ? this.formatDate(this.to) : "";
    },
    closeAccountStatementModal() {
      this.accountStatementData = [];
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
